var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5535 1.005C12.5178 0.5355 11.4104 0.194289 10.2526 0C10.1104 0.249071 9.94429 0.584077 9.82976 0.850574C8.599 0.671245 7.37956 0.671245 6.17144 0.850574C6.05693 0.584077 5.88704 0.249071 5.74357 0C4.58454 0.194289 3.47584 0.536754 2.44013 1.00748C0.351095 4.06602 -0.215207 7.04858 0.0679444 9.98879C1.4535 10.9913 2.79627 11.6003 4.11638 11.9988C4.44233 11.5641 4.73302 11.1021 4.98345 10.6152C4.5065 10.4396 4.04969 10.2229 3.61805 9.97137C3.73256 9.88917 3.84457 9.80324 3.95279 9.71482C6.58546 10.9079 9.44593 10.9079 12.0472 9.71482C12.1566 9.80324 12.2686 9.88917 12.3819 9.97137C11.949 10.2242 11.4909 10.4408 11.014 10.6165C11.2644 11.1021 11.5538 11.5654 11.881 12C13.2024 11.6015 14.5464 10.9925 15.932 9.98879C16.2642 6.58034 15.3644 3.62516 13.5535 1.005ZM5.34212 8.18059C4.55181 8.18059 3.9037 7.46576 3.9037 6.59528C3.9037 5.72479 4.53797 5.00873 5.34212 5.00873C6.14628 5.00873 6.79437 5.72354 6.78053 6.59528C6.78178 7.46576 6.14628 8.18059 5.34212 8.18059ZM10.6578 8.18059C9.86752 8.18059 9.21941 7.46576 9.21941 6.59528C9.21941 5.72479 9.85366 5.00873 10.6578 5.00873C11.462 5.00873 12.1101 5.72354 12.0962 6.59528C12.0962 7.46576 11.462 8.18059 10.6578 8.18059Z",
    fill: "#5865F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDs);
export default __webpack_public_path__ + "static/media/ds.af072013e9a6d04a25e9e8b13260e6cf.svg";
export { ForwardRef as ReactComponent };